import {
  Component,
  OnInit,
  AfterViewInit,
  ViewChild,
  ElementRef,
  Input,
  SimpleChanges,
  Output,
  EventEmitter,
  ViewChildren,
  QueryList,
} from '@angular/core';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { TranslateService } from '@ngx-translate/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { HistoryComponent } from 'src/app/shared/components/modal/history/history.component';
import {
  NgbModal,
  ModalDismissReasons,
  NgbModalOptions,
} from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormControl, FormBuilder, FormArray } from '@angular/forms';
import { Validators } from '@angular/forms';
import { GlobalsService } from 'src/app/shared/services/globals';
import { EventEmitterService } from '../../services/event-emitter.service';
import { Alert } from '../../models/alert.model';
import * as moment from 'moment';
import { PdaService } from '../../services/pda.service';
import { ModalConfirmComponent } from '../modal/confirm/modal-confirm.component';
import { build$ } from 'protractor/built/element';
import { isSameOrBefore } from 'ngx-bootstrap/chronos/utils/date-compare';
@Component({
  selector: 'app-plan-development',
  templateUrl: './plan-development.component.html',
  styleUrls: ['./plan-development.component.scss'],
})
export class PlanDevelopmentComponent implements OnInit {
  dataSource = [];
  listData = [];
  listHistoric = [];
  primaryOpen: boolean = true;
  secondaryOpen: boolean = true;
  smallSize: boolean;
  newAction: boolean = false;
  datosNewAction: FormGroup;
  actionsList: FormGroup;
  search = '';
  modulo = 'actions';
  causas: any = [];
  resp: any = [];
  selectedActions: any = [];
  @Input() planSelected: any;
  @Input() fromHistoric: boolean;
  @Input() newlyCreated: boolean;

  @Output() public emitChangeSelected = new EventEmitter();
  @Output() public emitEdited = new EventEmitter();
  @Output() public emitLoaded = new EventEmitter();
  @Output() public emitReloadStats = new EventEmitter();
  // @ViewChild('tarea', { static: false }) tarea: ElementRef;
  // @ViewChild('tarea1', { static: false }) tarea1: ElementRef;
  // @ViewChild('tarea2', { static: false }) tarea2: ElementRef;
  // @ViewChild('tarea3', { static: false }) tarea3: ElementRef;
  // @ViewChild('tarea4', { static: false }) tarea4: ElementRef;
  @ViewChildren('tarea') tarea: QueryList<ElementRef>;
  @ViewChildren('tarea1') tarea1: QueryList<ElementRef>;
  @ViewChildren('tarea2') tarea2: QueryList<ElementRef>;
  @ViewChildren('tarea3') tarea3: QueryList<ElementRef>;
  @ViewChildren('tarea4') tarea4: QueryList<ElementRef>;
  saving: boolean;
  editable: boolean;
  edit4: any;
  edit3: any;
  edit2: any;
  edit1: any;
  format: string;
  constructor(
    private translate: TranslateService,
    private breakpointObserver: BreakpointObserver,
    private modalService: NgbModal,
    private fb: FormBuilder,
    private globals: GlobalsService,
    private emit: EventEmitterService,
    private el: ElementRef,
    private pda: PdaService,
    private emitService: EventEmitterService
  ) {
    this.actionsList = this.fb.group({
      list: this.fb.array([]),
    });
  }
  toggleEditable(): void {
    this.editable = !this.editable;
  }
  ngAfterViewChecked() {
    if (this.editable) {
    }
  }
  ngAfterViewInit() {
    this.tarea.changes.subscribe(() => {
      if (this.tarea.length > 0) {
        this.tarea.first.nativeElement.focus();
      }
    });
    this.tarea1.changes.subscribe(() => {
      if (this.tarea1.length > 0) {
        this.tarea1.first.nativeElement.focus();
      }
    });
    this.tarea2.changes.subscribe(() => {
      if (this.tarea2.length > 0) {
        this.tarea2.first.nativeElement.focus();
      }
    });
    this.tarea3.changes.subscribe(() => {
      if (this.tarea3.length > 0) {
        this.tarea3.first.nativeElement.focus();
      }
    });
    this.tarea4.changes.subscribe(() => {
      if (this.tarea4.length > 0) {
        this.tarea4.first.nativeElement.focus();
      }
    });
  }
  ngOnInit(): void {
    const layoutChanges = this.breakpointObserver.observe([
      '(min-width: 989px)',
    ]);
    layoutChanges.subscribe((result) => {
      this.smallSize = result.matches;
    });
    this.translate.currentLang == 'es'
    ? (this.format = 'DD/MM/YYYY')
    : (this.format = 'MM/DD/YYYY');
    this.datosNewAction = this.fb.group({
      tarea: [
        '',
        [
          Validators.required,
          Validators.maxLength(255),
          Validators.pattern('^[a-zA-Z0-9-_ +&()=;^.,@%#${}ñÑáéíóúÁÉÍÓÚ]+$'),
        ],
      ],
      causas: ['', Validators.required],
      responsable: ['', Validators.required],
      corresponsable: [''],
      prioridad: [''],
      recursos: ['', Validators.required],
      materiales: [''],
      servicios: [''],
      costos: [''],
      fecha_notificacion: ['', Validators.required],
      fecha_inicio: ['', Validators.required],
      fecha_fin: ['', Validators.required],
      fecha_ejecucion: ['', Validators.required],
      fecha_validacion: ['', Validators.required],
      cerrada: ['', Validators.required],
      en_ejecucion: ['', Validators.required],
      notas: [''],
    });
  }
  emitEdit(event) {
    this.emitEdited.emit(true);
    this.listData.forEach((action) => {
      if (action.id == event.id) {
        this.editAcionStages(action, event);
      }
      if (action.accion_hijo) {
        action.accion_hijo.forEach((action1) => {
          if (action1.id == event.id) {
            this.editAcionStages(action1, event);
          }
          if (action1.accion_hijo) {
            action1.accion_hijo.forEach((action2) => {
              if (action2.id == event.id) {
                this.editAcionStages(action2, event);
              }
              if (action2.accion_hijo) {
                action2.accion_hijo.forEach((action3) => {
                  if (action3.id == event.id) {
                    this.editAcionStages(action3, event);
                  }
                  if (action3.accion_hijo) {
                    action3.accion_hijo.forEach((action4) => {
                      if (action4.id == event.id) {
                        this.editAcionStages(action4, event);
                      }
                    });
                  }
                });
              }
            });
          }
        });
      }
    });
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.datosNewAction = this.fb.group({
      tarea: [
        '',
        [
          Validators.required,
          Validators.maxLength(255),
          Validators.pattern('^[a-zA-Z0-9-_ +&()=;^.,@%#${}ñÑáéíóúÁÉÍÓÚ]+$'),
        ],
      ],
      causas: ['', Validators.required],
      responsable: ['', Validators.required],
      corresponsable: [''],
      prioridad: [''],
      recursos: ['', Validators.required],
      materiales: [''],
      servicios: [''],
      costos: [''],
      fecha_notificacion: ['', Validators.required],
      fecha_inicio: ['', Validators.required],
      fecha_fin: ['', Validators.required],
      fecha_ejecucion: ['', Validators.required],
      fecha_validacion: ['', Validators.required],
      cerrada: ['', Validators.required],
      en_ejecucion: ['', Validators.required],
      notas: [''],
    });
    if (this.newAction) {
      this.newAction = !this.newAction;
    }
    // this.actionsList = this.fb.group({
    //   list: this.fb.array([]),
    // });
    
    if (this.planSelected.length != 0) {
      // console.log(this.planSelected);

      //se obtiene la lista de acciones del plan seleccionado
      if (this.planSelected.acciones) {
        if (this.planSelected.acciones.length) {
          this.getActionsList();
        } else {
          this.listData = [];
        }
      } else {
        this.emitLoaded.emit(true);
      }
    }
    // this.primaryOpen = this.newlyCreated;
    // this.secondaryOpen = this.newlyCreated;
    this.editable = this.newlyCreated;
    this.newAction = this.newlyCreated;
  }
  getActionsList() {
    this.pda.getHistoricActionList(this.planSelected.id).subscribe(
      (data: any) => {
        this.listHistoric = data.data;
      },
      (err) => {
        this.listHistoric = [];
      }
    );
    this.pda.getPlanAction(this.planSelected.id).subscribe(
      (data: any) => {
        this.emitLoaded.emit(true);
        this.listData = data.data.acciones;
        
        this.listData.map((x, index, array) => {
          let id = x.id;
          x.saved = true;
          x.details = false;
          x.edit = false;
          x.num = index;
          x.hijo = 0;
          x.checked = false;
          x.etapa = 'No tratado';
          this.formatDates(x);
          this.actionStages(x);

          if (x.accion_hijo) {
            x.accion_hijo.map((j, index, array) => {
              j.saved = true;
              j.details = false;
              j.edit = false;
              j.num = index;
              j.hijo = 1;
              j.checked = false;
              j.etapa = 'No tratado';

              j.accion_padre = x.id;
              this.formatDates(j);
              this.actionStages(j);

              if (j.accion_hijo) {
                j.accion_hijo.map((k, index, array) => {
                  k.saved = true;
                  k.details = false;
                  k.edit = false;
                  k.num = index;
                  k.hijo = 2;
                  k.checked = false;
                  k.accion_padre = j.id;
                  k.etapa = 'No tratado';
                  this.formatDates(k);
                  this.actionStages(k);

                  if (k.accion_hijo) {
                    k.accion_hijo.map((l, index, array) => {
                      l.saved = true;
                      l.details = false;
                      l.edit = false;
                      l.num = index;
                      l.hijo = 3;
                      l.checked = false;
                      l.accion_padre = k.id;
                      l.etapa = 'No tratado';

                      this.formatDates(l);
                      this.actionStages(l);
                    });
                  }
                });
              }
            });
          }
        });
      },
      (err) => {
        console.log(err);
        
        this.listData = [];
      }
    );
  }
  formatDates(x): void {
    
    
    if (x.fecha_inicio) {
      x.fecha_inicio = moment(x.fecha_inicio, 'DD-MM-YYYY').format(this.format);
    }
    if (x.fecha_notificacion) {
      x.fecha_notificacion = moment(x.fecha_notificacion, 'DD-MM-YYYY').format(this.format);
    }
    if (x.fecha_fin) {
      x.fecha_fin_utc = x.fecha_fin;

      x.fecha_fin = moment(x.fecha_fin, 'DD-MM-YYYY').format(this.format);
     
    }
    if (x.fecha_ejecucion) {
      x.fecha_ejecucion_utc = x.fecha_ejecucion;
      x.fecha_ejecucion = moment(x.fecha_ejecucion, 'DD-MM-YYYY').format(this.format);
     
    }
    if (x.fecha_validacion) {
      x.fecha_validacion = moment(x.fecha_validacion, 'DD-MM-YYYY').format(this.format);
    }
  }
  editAcionStages(x, event): void {
    const fechaFin = event.fecha_fin instanceof Date? moment(event.fecha_fin.toISOString()):moment(event.fecha_fin,this.format);
    const fechaEjec = event.fecha_ejecucion instanceof Date? moment(event.fecha_ejecucion.toISOString()):moment(event.fecha_ejecucion,this.format);
    const fechaFinShow =event.fecha_fin instanceof Date? moment(event.fecha_fin.toISOString()).format(this.format):moment(event.fecha_fin,this.format).format(this.format);
    if (event.fecha_fin) {
      x.fecha_fin=fechaFinShow;
    }
    if (event.fecha_notificacion) {
      x.etapa = 'Notificado';
    }
    if (event.fecha_inicio) {
      x.etapa = 'Planificado';
    }
    if (event.en_ejecucion == 1) {
      x.etapa = 'En ejecución';
    }
    if (event.fecha_ejecucion) {
      x.etapa = 'Ejecutado';
    }
    if (event.fecha_validacion) {
      x.etapa = 'Validado';
    }
    if ((x.etapa == 'Planificado' && x.fecha_fin) || x.etapa == 'Ejecucion') {
      const today = moment();
      if(moment(today).isSameOrBefore(fechaFin,'day')){
        x.estado = 'En fecha';
      }else{
        x.estado = 'No en fecha';
      }
    }
    if (x.cerrada == 2 && x.fecha_fin) {
      const today = moment();
      if(moment(today).isSameOrBefore(fechaFin,'day')){
        x.estado = 'En fecha';
      }else{
        x.estado = 'No en fecha';
      }
    }
    if (x.etapa == 'Ejecutado' || x.etapa == 'Validado') {
      if(moment(fechaEjec).isSameOrBefore(fechaFin,'day')){
        x.estado = 'En fecha';
      }else{
        x.estado = 'No en fecha';
      }
    }
  }
  actionStages(x): void {
    
    if (x.fecha_notificacion) {
      x.etapa = 'Notificado';
    }
    if (x.fecha_inicio) {
      x.etapa = 'Planificado';
    }
    if (x.en_ejecucion == 1) {
      x.etapa = 'En ejecución';
    }
    if (x.fecha_ejecucion) {
      x.etapa = 'Ejecutado';
    }
    if (x.fecha_validacion) {
      x.etapa = 'Validado';
    }
    if ((x.etapa == 'Planificado' && x.fecha_fin) || x.etapa == 'Ejecucion') {
     const today = moment();
     const fechaFin = moment(x.fecha_fin,this.format);
      if(moment(today).isSameOrBefore(fechaFin,'day')){
        x.estado = 'En fecha';
      }else{
        x.estado = 'No en fecha';
      }
      
    }

    if (x.cerrada == 2 && x.fecha_fin) {
     const today = moment();
     const fechaFin = moment(x.fecha_fin,this.format);
      if(moment(today).isSameOrBefore(fechaFin,'day')){
        x.estado = 'En fecha';
      }else{
        x.estado = 'No en fecha';
      }
      
    }
    if (x.etapa == 'Ejecutado' || x.etapa == 'Validado') {
     const fechaFin = moment(x.fecha_fin,this.format);
     const fechaEjec = moment(x.fecha_ejecucion,this.format);
      if(moment(fechaEjec).isSameOrBefore(fechaFin,'day')){
        x.estado = 'En fecha';
      }else{
        x.estado = 'No en fecha';
      }
    }
  }
  openPrimary() {
    this.primaryOpen = !this.primaryOpen;
  }
  openSecondary() {
    this.secondaryOpen = !this.secondaryOpen;
    // this.emitService.clickSave('causas');
    // this.emitService.savedData.subscribe((res) => {});
  }
  /**
   * @name openInside
   * @author Daniel Ramirez
   * @description se muestran los detalles de cada accion
   */
  openInside(i) {
    this.listData[i].details = !this.listData[i].details;
  }
  /**
   * @name openHijo
   * @author Daniel Ramirez
   * @description se muestran los detalles de las acciones hijas
   */
  openHijo(i, j) {
    this.listData[i].accion_hijo[j].details =
      !this.listData[i].accion_hijo[j].details;
  }
  openHijo2(i, j, k) {
    this.listData[i].accion_hijo[j].accion_hijo[k].details =
      !this.listData[i].accion_hijo[j].accion_hijo[k].details;
  }
  openHijo3(i, j, k, l) {
    this.listData[i].accion_hijo[j].accion_hijo[k].accion_hijo[l].details =
      !this.listData[i].accion_hijo[j].accion_hijo[k].accion_hijo[l].details;
  }
  /**
   * @name selectActions
   * @author Daniel Ramirez
   * @description se agregan o eliminan las acciones seleccionadas al array
   */
  selectActions(event, data, i) {
    // if (event.target.checked) {
    //   this.selectedActions.push(data);
    // } else {
    //   this.selectedActions.splice(i, 1);
    // }
  }
  /**
   * @name sangriaUp,sangriaDown
   * @author Daniel Ramirez
   * @description se agrega o quita sangria a la accion seleccionada,utilizando como base de sangria a la accion inmediatamente superior
   */
  sangriaUp() {
    let body = { accion: [] };
    let first_indent = [];
    let valid = true;
    if (this.listData[0].checked) {
      valid = false;
    } else {
      let filter = this.listData.filter((x) => x.checked == true);
      if (!filter.length) {
        valid = false;
      }
      for (let i = 0; i < this.listData.length; i++) {
        //RAMA PRINCIPAL
        if (this.listData[i].checked) {
          first_indent.push(i);
          valid = true;
          body.accion.push({
            accion_padre_id: this.listData[first_indent[0] - 1].id,
            accion_hijo_id: this.listData[i].id,
          });
        }
        if (this.listData[i].accion_hijo.length) {
          for (let j = 0; j < this.listData[i].accion_hijo.length; j++) {
            //PRIMER HIJO
            if (this.listData[i].accion_hijo[j].checked) {
              if (j == 0) {
                valid = false;
                return;
              } else {
                valid = true;
                body.accion.push({
                  accion_padre_id: this.listData[i].accion_hijo[j - 1].id,
                  accion_hijo_id: this.listData[i].accion_hijo[j].id,
                });
              }
            }
            if (this.listData[i].accion_hijo[j].accion_hijo.length) {
              for (
                let k = 0;
                k < this.listData[i].accion_hijo[j].accion_hijo.length;
                k++
              ) {
                if (this.listData[i].accion_hijo[j].accion_hijo[k].checked) {
                  //SEGUNDO HIJO
                  if (k == 0) {
                    valid = false;
                    return;
                  } else {
                    body.accion.push({
                      accion_padre_id:
                        this.listData[i].accion_hijo[j].accion_hijo[k - 1].id,
                      accion_hijo_id:
                        this.listData[i].accion_hijo[j].accion_hijo[k].id,
                    });
                  }
                }
                if (
                  this.listData[i].accion_hijo[j].accion_hijo[k].accion_hijo
                    .length
                ) {
                  for (
                    let l = 0;
                    l <
                    this.listData[i].accion_hijo[j].accion_hijo[k].accion_hijo
                      .length;
                    l++
                  ) {
                    if (
                      this.listData[i].accion_hijo[j].accion_hijo[k]
                        .accion_hijo[l].checked
                    ) {
                      //TERCER HIJO
                      if (l == 0) {
                        valid = false;
                        return;
                      } else {
                        body.accion.push({
                          accion_padre_id:
                            this.listData[i].accion_hijo[j].accion_hijo[k]
                              .accion_hijo[l - 1].id,
                          accion_hijo_id:
                            this.listData[i].accion_hijo[j].accion_hijo[k]
                              .accion_hijo[l].id,
                        });
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      if (valid) {
        this.pda.sangrias(body, this.planSelected.id).subscribe(
          (res) => {
            Alert.buildSuccessAlert(
              this.translate.instant('action_plan.plan_development.indent')
            );
            this.changeSelected(this.planSelected.id);
          },
          (err) => {
            Alert.buildErrorAlert(
              this.translate.instant(
                'action_plan.plan_development.indent_error'
              )
            );
          }
        );
      } else {
        Alert.buildErrorAlert(
          this.translate.instant('action_plan.plan_development.indent_first')
        );
      }
    }
  }
  sangriaDown() {
    let body = { accion_reestablecer: [] };
    let valid = true;
    for (let i = 0; i < this.listData.length; i++) {
      if (this.listData[i].checked) {
        valid = false;
        Alert.buildErrorAlert(
          this.translate.instant('action_plan.plan_development.indent_root')
        );
      } else {
        if (this.listData[i].accion_hijo.length) {
          for (let j = 0; j < this.listData[i].accion_hijo.length; j++) {
            if (this.listData[i].accion_hijo[j].checked) {
              body.accion_reestablecer.push({
                accion_id: this.listData[i].accion_hijo[j].id,
              });
            }
            if (this.listData[i].accion_hijo[j].accion_hijo.length) {
              for (
                let k = 0;
                k < this.listData[i].accion_hijo[j].accion_hijo.length;
                k++
              ) {
                if (this.listData[i].accion_hijo[j].accion_hijo[k].checked) {
                  body.accion_reestablecer.push({
                    accion_id:
                      this.listData[i].accion_hijo[j].accion_hijo[k].id,
                  });
                }
                if (
                  this.listData[i].accion_hijo[j].accion_hijo[k].accion_hijo
                    .length
                ) {
                  for (
                    let l = 0;
                    l <
                    this.listData[i].accion_hijo[j].accion_hijo[k].accion_hijo
                      .length;
                    l++
                  ) {
                    if (
                      this.listData[i].accion_hijo[j].accion_hijo[k]
                        .accion_hijo[l].checked
                    ) {
                      body.accion_reestablecer.push({
                        accion_id:
                          this.listData[i].accion_hijo[j].accion_hijo[k]
                            .accion_hijo[l].id,
                      });
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    if (valid) {
      this.pda.sangrias(body, this.planSelected.id).subscribe(
        (res) => {
          Alert.buildSuccessAlert(
            this.translate.instant('action_plan.plan_development.indent')
          );
          this.changeSelected(this.planSelected.id);
        },
        (err) => {
          Alert.buildErrorAlert(
            this.translate.instant('action_plan.plan_development.indent_error')
          );
        }
      );
    }
  }
  /**
   * @name moveUp,moveDown
   * @author Daniel Ramirez
   * @description se cambia el orden de  la lista de acciones seleccionadas
   */
  moveUp() {
    let valid_first = true;
    let body = { accion_subir: [] };

    for (let i = 0; i < this.listData.length; i++) {
      if (this.listData[i].checked) {
        if (i != 0) {
          body.accion_subir.push({
            accion_id: this.listData[i].id,
            order: this.listData[i - 1].orden,
          });
        } else {
          valid_first = false;
          Alert.buildErrorAlert(
            this.translate.instant('action_plan.plan_development.move_up')
          );
          return;
        }
      }
      if (this.listData[i].accion_hijo.length) {
        for (let j = 0; j < this.listData[i].accion_hijo.length; j++) {
          if (this.listData[i].accion_hijo[j].checked) {
            if (j != 0) {
              body.accion_subir.push({
                accion_id: this.listData[i].accion_hijo[j].id,
                order: this.listData[i].accion_hijo[j - 1].orden,
              });
            } else {
              valid_first = false;
              Alert.buildErrorAlert(
                this.translate.instant('action_plan.plan_development.move_up')
              );
              return;
            }
          }
          if (this.listData[i].accion_hijo[j].accion_hijo.length) {
            for (
              let k = 0;
              k < this.listData[i].accion_hijo[j].accion_hijo.length;
              k++
            ) {
              if (this.listData[i].accion_hijo[j].accion_hijo[k].checked) {
                if (k != 0) {
                  body.accion_subir.push({
                    accion_id:
                      this.listData[i].accion_hijo[j].accion_hijo[k].id,
                    order:
                      this.listData[i].accion_hijo[j].accion_hijo[k - 1].orden,
                  });
                } else {
                  valid_first = false;
                  Alert.buildErrorAlert(
                    this.translate.instant(
                      'action_plan.plan_development.move_up'
                    )
                  );
                  return;
                }
              }
              if (
                this.listData[i].accion_hijo[j].accion_hijo[k].accion_hijo
                  .length
              ) {
                for (
                  let l = 0;
                  l < this.listData[i].accion_hijo[j].accion_hijo.length;
                  l++
                ) {
                  if (
                    this.listData[i].accion_hijo[j].accion_hijo[k].accion_hijo[
                      l
                    ].checked
                  ) {
                    if (k != 0) {
                      body.accion_subir.push({
                        accion_id:
                          this.listData[i].accion_hijo[j].accion_hijo[k]
                            .accion_hijo[l].id,
                        order:
                          this.listData[i].accion_hijo[j].accion_hijo[k]
                            .accion_hijo[l - 1].orden,
                      });
                    } else {
                      valid_first = false;
                      Alert.buildErrorAlert(
                        this.translate.instant(
                          'action_plan.plan_development.move_up'
                        )
                      );
                      return;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    valid_first
      ? this.pda.actionOrder(body, this.planSelected.id).subscribe(
          (res) => {
            Alert.buildSuccessAlert(
              this.translate.instant('action_plan.plan_development.order')
            );
            this.changeSelected(this.planSelected.id);
          },
          (err) => {
            Alert.buildErrorAlert(
              this.translate.instant('action_plan.plan_development.order_error')
            );
          }
        )
      : Alert.buildErrorAlert(
          this.translate.instant('action_plan.plan_development.move_up')
        );
  }

  moveDown() {
    let valid_first = true;
    let body = { accion_bajar: [] };

    for (let i = 0; i < this.listData.length; i++) {
      if (this.listData[i].checked) {
        if (i != this.listData.length - 1) {
          body.accion_bajar.push({
            accion_id: this.listData[i].id,
            order: this.listData[i + 1].orden,
          });
        } else {
          valid_first = false;
          Alert.buildErrorAlert(
            this.translate.instant('action_plan.plan_development.move_down')
          );
          return;
        }
      }
      if (this.listData[i].accion_hijo.length) {
        for (let j = 0; j < this.listData[i].accion_hijo.length; j++) {
          if (this.listData[i].accion_hijo[j].checked) {
            if (j != this.listData[i].accion_hijo.length - 1) {
              body.accion_bajar.push({
                accion_id: this.listData[i].accion_hijo[j].id,
                order: this.listData[i].accion_hijo[j + 1].orden,
              });
            } else {
              valid_first = false;
              Alert.buildErrorAlert(
                this.translate.instant('action_plan.plan_development.move_down')
              );
              return;
            }
          }
          if (this.listData[i].accion_hijo[j].accion_hijo.length) {
            for (
              let k = 0;
              k < this.listData[i].accion_hijo[j].accion_hijo.length;
              k++
            ) {
              if (this.listData[i].accion_hijo[j].accion_hijo[k].checked) {
                if (
                  k !=
                  this.listData[i].accion_hijo[j].accion_hijo.length - 1
                ) {
                  body.accion_bajar.push({
                    accion_id:
                      this.listData[i].accion_hijo[j].accion_hijo[k].id,
                    order:
                      this.listData[i].accion_hijo[j].accion_hijo[k + 1].orden,
                  });
                } else {
                  valid_first = false;
                  Alert.buildErrorAlert(
                    this.translate.instant(
                      'action_plan.plan_development.move_down'
                    )
                  );
                  return;
                }
              }
              if (
                this.listData[i].accion_hijo[j].accion_hijo[k].accion_hijo
                  .length
              ) {
                for (
                  let l = 0;
                  l <
                  this.listData[i].accion_hijo[j].accion_hijo[k].accion_hijo
                    .length;
                  l++
                ) {
                  if (
                    this.listData[i].accion_hijo[j].accion_hijo[k].accion_hijo[
                      l
                    ].checked
                  ) {
                    if (
                      l !=
                      this.listData[i].accion_hijo[j].accion_hijo[k].accion_hijo
                        .length -
                        1
                    ) {
                      body.accion_bajar.push({
                        accion_id:
                          this.listData[i].accion_hijo[j].accion_hijo[k]
                            .accion_hijo[l].id,
                        order:
                          this.listData[i].accion_hijo[j].accion_hijo[k]
                            .accion_hijo[l + 1].orden,
                      });
                    } else {
                      valid_first = false;
                      Alert.buildErrorAlert(
                        this.translate.instant(
                          'action_plan.plan_development.move_down'
                        )
                      );
                      return;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    valid_first
      ? this.pda.actionOrder(body, this.planSelected.id).subscribe(
          (res) => {
            Alert.buildSuccessAlert(
              this.translate.instant('action_plan.plan_development.order')
            );
            this.changeSelected(this.planSelected.id);
          },
          (err) => {
            Alert.buildErrorAlert(
              this.translate.instant('action_plan.plan_development.order_error')
            );
          }
        )
      : Alert.buildErrorAlert(
          this.translate.instant('action_plan.plan_development.move_down')
        );
  }
  /**
   * @name openHistory
   * @author Daniel Ramirez
   * @description se abre el modal de acciones historicas
   */
  openHistory() {
    const modalRef = this.modalService.open(HistoryComponent, {
      ariaLabelledBy: 'modal-basic-title',
      centered: true,
      windowClass: 'myCustomClass',
    });

    modalRef.componentInstance.data = this.planSelected;
    modalRef.componentInstance.clickClose.subscribe((resp: any) => {
      this.changeSelected(resp);
    });
  }
  /**
   * @name addNewAction
   * @author Daniel Ramirez
   * @description se abre o cierra el formulario para crear una accion
   */
  addNewAction() {
    if (this.datosNewAction.get('tarea').value) {
      const modalRef = this.modalService.open(ModalConfirmComponent, {
        ariaLabelledBy: 'modal-basic-title',
        centered: true,
      });
      modalRef.componentInstance.nombre =
        this.datosNewAction.get('tarea').value;
      modalRef.componentInstance.from = 'add_new_action';
      modalRef.componentInstance.title =
        this.translate.currentLang == 'es'
          ? 'AGREGAR NUEVA ACCIÓN'
          : 'ADD NEW ACTION';
      modalRef.componentInstance.clickClose.subscribe((resp: any) => {
        this.addNew();
      });
      modalRef.componentInstance.clickDismiss.subscribe((resp: any) => {
        this.datosNewAction.reset();
      });
    } else {
      this.newAction = !this.newAction;

      this.datosNewAction.reset();
    }
  }
  onBlurMethod(event) {
    if (!event.target.value) {
      this.newAction = !this.newAction;

      this.datosNewAction.reset();
    }
  }
  /**
   * @name order
   * @author Daniel Ramirez
   * @description si el formulario de creaccion de accion es valido, se crea una nueva accion dentro del plan seleccionado
   */
  addNew() {
    if (this.datosNewAction.get('tarea').value) {
      if(this.datosNewAction.get('tarea').value.length > 4){
        this.saving = true;
        let body = {
          accion: [
            {
              tarea: this.datosNewAction.get('tarea').value,
            },
          ],
        };
        this.pda.createAction(this.planSelected.id, body).subscribe(
          (res) => {
            this.saving = false;
            Alert.buildSuccessAlert(
              this.translate.instant('action_plan.plan_development.created')
            );
            this.changeSelected(1);
            this.newAction = false;
          },
          (err) => {
            console.log(err);
            this.saving = false;
            Alert.buildErrorAlert(
              this.translate.instant('action_plan.plan_development.error_create')
            );
          }
        );
      }else{
        Alert.buildErrorAlert(
          this.translate.instant('action_plan.plan_development.error_length')
        );
      }
     
    } else {
      // this.validateAllFormFields(this.datosNewAction);
      Alert.buildErrorAlert(
        this.translate.instant('action_plan.modal_save.error_empty')
      );
    }

    this.datosNewAction.reset();
  }
  /**
   * @name deleteAction
   * @author Daniel Ramirez
   * @description se elimina la accion seleccionada
   */
  deleteAction(accionId, nombre) {
    const modalRef = this.modalService.open(ModalConfirmComponent, {
      ariaLabelledBy: 'modal-basic-title',
      centered: true,
    });

    let body = { accion_id: [accionId] };
    modalRef.componentInstance.nombre = nombre;
    modalRef.componentInstance.from = 'delete_action';
    modalRef.componentInstance.clickClose.subscribe((resp: any) => {
      this.pda.deleteSelected(body, this.planSelected.id).subscribe(
        (res) => {
          this.changeSelected(this.planSelected.id);
          Alert.buildSuccessAlert(
            this.translate.instant('action_plan.plan_development.delete')
          );
        },
        (err) => {
          console.log(err);
          Alert.buildErrorAlert(
            this.translate.instant('action_plan.plan_development.error_delete')
          );
        }
      );
    });
  }
  /**
   * @name deleteAction
   * @author Daniel Ramirez
   * @description se elimina la accion seleccionada
   */
  deleteSelected() {
    let nombres = [];
    let body = { accion_id: [] };
    this.listData.forEach((padre) => {
      if (padre.checked) {
        body.accion_id.push(padre.id);
        nombres.push('"' + padre.tarea + '"');
        if (padre.accion_hijo.length) {
          padre.accion_hijo.forEach((primer_hijo) => {
            if (primer_hijo.checked) {
              body.accion_id.push(primer_hijo.id);
              nombres.push('"' + primer_hijo.tarea + '"');
              if (primer_hijo.accion_hijo.length) {
                primer_hijo.accion_hijo.forEach((segundo_hijo) => {
                  if (segundo_hijo.checked) {
                    body.accion_id.push(segundo_hijo.id);
                    nombres.push('"' + segundo_hijo.tarea + '"');
                    if (segundo_hijo.accion_hijo.length) {
                      segundo_hijo.accion_hijo.forEach((tercer_hijo) => {
                        if (tercer_hijo.checked) {
                          body.accion_id.push(tercer_hijo.id);
                          nombres.push('"' + tercer_hijo.tarea + '"');
                        }
                      });
                    }
                  }
                });
              }
            }
          });
        }
      }
    });
    if (body.accion_id.length) {
      const modalRef = this.modalService.open(ModalConfirmComponent, {
        ariaLabelledBy: 'modal-basic-title',
        centered: true,
      });
      modalRef.componentInstance.nombre = nombres;
      modalRef.componentInstance.from = 'delete_selected';
      modalRef.componentInstance.clickClose.subscribe((resp: any) => {
        this.pda.deleteSelected(body, this.planSelected.id).subscribe(
          (res) => {
            this.changeSelected(this.planSelected.id);
            Alert.buildSuccessAlert(
              this.translate.instant('action_plan.plan_development.delete')
            );
          },
          (err) => {
            console.log(err);
            Alert.buildErrorAlert(
              this.translate.instant(
                'action_plan.plan_development.error_delete'
              )
            );
          }
        );
      });
    } else {
      Alert.buildErrorAlert(
        this.translate.instant('action_plan.plan_development.empty_actions')
      );
    }
  }
  /**
   * @name editName
   * @author Daniel Ramirez
   * @description se elimina la accion seleccionada
   */
  editName(data, num) {
    this.datosNewAction.get('tarea').patchValue(data.tarea);
  }
  /**
   * @name editAction
   * @author Daniel Ramirez
   * @description se elimina la accion seleccionada
   */
  editAction(data) {
    let causas = [];
    let resp = [];
    let corresp = [];
    this.causas = [];
    this.resp = [];
    if (data.causa_pda.length) {
      data.causa_pda.forEach((element) => {
        causas.push(element.causa);
        this.causas.push({ causa: element.causa });
      });
    }
    if (data.responsable.length) {
      data.responsable.forEach((element) => {
        if (element.tipo == 1) {
          resp.push(element.usuario_organizacion.usuario.name);
          this.resp.push({
            usuario_id: element.usuario_organizacion.usuario.id,
            tipo: 1,
            nombre_responsable: element.usuario_organizacion.usuario.name,
          });
        } else {
          if (element.usuario_organizacion) {
            this.resp.push({
              usuario_id: element.usuario_organizacion.usuario.id,
              tipo: 2,
              nombre_responsable: element.usuario_organizacion.usuario.name,
            });
          } else {
            this.resp.push({
              tipo: 2,
              nombre_responsable: element.nombre_responsable,
            });
          }
          corresp.push(
            element.usuario_organizacion
              ? element.usuario_organizacion.usuario.name
              : element.nombre_responsable
          );
        }
      });
    }
    if (this.datosNewAction.get('tarea').value) {
      this.saving = true;
      let body;
      if (data.fecha_notificacion) {
        body = {
          tarea: this.datosNewAction.get('tarea').value,
          prioridad: data.prioridad ? data.prioridad : null,
          recursos: data.recursos ? data.recursos : null,
          servicios: data.servicios ? data.servicios : null,
          costos: data.costos ? data.costos : null,
          fecha_notificacion: moment(
            data.fecha_notificacion ? data.fecha_notificacion : null,
            'DD/MM/YYYY'
          ).format('YYYY-MM-DD'),
          fecha_inicio: moment(
            data.fecha_inicio ? data.fecha_inicio : null,
            'DD/MM/YYYY'
          ).format('YYYY-MM-DD'),
          fecha_fin: moment(
            data.fecha_fin ? data.fecha_fin : null,
            'DD/MM/YYYY'
          ).format('YYYY-MM-DD'),
          fecha_ejecucion: moment(
            data.fecha_ejecucion ? data.fecha_ejecucion : null,
            'DD/MM/YYYY'
          ).format('YYYY-MM-DD'),
          fecha_validacion: moment(
            data.fecha_validacion ? data.fecha_validacion : null,
            'DD/MM/YYYY'
          ).format('YYYY-MM-DD'),
          cerrada: data.cerrada ? data.cerrada : null,
          en_ejecucion: data.en_ejecucion ? data.en_ejecucion : null,
          notas: data.notas ? data.notas : null,
          causas: data.causa_pda ? this.causas : null,
          responsables: data.responsable ? this.resp : null,
        };
        if (data.accion_padre) {
          body.accion_padre_id = data.accion_padre;
        }
      } else {
        body = { tarea: this.datosNewAction.get('tarea').value };
        if (data.accion_padre) {
          body.accion_padre_id = data.accion_padre;
        }
      }

      this.pda.editAction(this.planSelected.id, body, data.id).subscribe(
        (res) => {
          this.changeSelected(this.planSelected.id);
          Alert.buildSuccessAlert(
            this.translate.instant('action_plan.plan_development.edit')
          );
          this.saving = false;
        },
        (err) => {
          console.log(err);
          Alert.buildErrorAlert(
            this.translate.instant('action_plan.plan_development.error_edit')
          );
          this.saving = false;
        }
      );
    } else {
      // this.validateAllFormFields(this.datosNewAction);
      Alert.buildErrorAlert(
        this.translate.instant('action_plan.modal_save.error_empty')
      );
    }

    this.datosNewAction.reset();
  }
  /**
   * @name changeSelected
   * @author Daniel Ramirez
   * @description se emite el plan seleccionado
   */
  changeSelected(id) {
    this.getActionsList();
    this.emitReloadStats.emit(this.listData);
  }
  /**
   * @name validateAllFormFields
   * @author Daniel Ramirez
   * @description validacion de formulario
   */
  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field);

      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
    for (const key of Object.keys(this.datosNewAction.controls)) {
      if (this.datosNewAction.controls[key].invalid) {
        const invalidControl = this.el.nativeElement.querySelector(
          '[formcontrolname="' + key + '"]'
        );

        invalidControl.focus();
        break;
      }
    }
  }
  onlyResp(data) {
    let resp = data.filter((resp) => resp.tipo == 1);
    return resp;
  }
}
